<template>
  <div v-if="hasAuth">
    <!-- 설정 권한이 필요한 컴포넌트 배치 -->
    <el-row type="flex" :gutter="4">
      <el-col :span="12" class="mr-b4">
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
      </el-col>
      <el-col :span="12" class="mr-b4">
        <w-ServiceMapSettingButton :obj-info="objInfo"></w-ServiceMapSettingButton>
      </el-col>
    </el-row>
  </div>
  <div v-else>
    <el-row>
        <w-common-setting-chart-type-popup-button :obj-info="objInfo"></w-common-setting-chart-type-popup-button>
    </el-row>
  </div>
</template>

<script>
import HambugerPopupMixin from '@/mixins/performance/hambuger-popup';
import WCommonSettingChartTypePopupButton from './CommonSettingChartTypePopupButton';
import WServiceMapSettingButton from './ServiceMapSettingButton';

export default {
  name: 'WServiceSlidingButtonGroup',
  components: {
    WCommonSettingChartTypePopupButton,
    WServiceMapSettingButton,
  },
  mixins: [HambugerPopupMixin],
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ServiceSlidingButtonGroup.vue